export const PENDING_INVITE_KEY = 'cc.portal.pendingInvite';

const readRecord = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_INVITE_KEY);
    if (!raw) { return null; }
    const parsed = JSON.parse(raw);
    const token = typeof parsed?.token === 'string' ? parsed.token.trim() : '';
    // Invite JWTs are comfortably below this bound. Rejecting an oversized or
    // malformed stash keeps the root redirect local and predictable even when
    // same-origin JavaScript has tampered with sessionStorage.
    if (!token || token.length > 4096) {
      sessionStorage.removeItem(PENDING_INVITE_KEY);
      return null;
    }
    return { token };
  } catch {
    sessionStorage.removeItem(PENDING_INVITE_KEY);
    return null;
  }
};

export function stashPendingInvite(token) {
  sessionStorage.setItem(PENDING_INVITE_KEY, JSON.stringify({ token: String(token) }));
}

export function consumePendingInvite() {
  const pending = readRecord();
  if (pending) { sessionStorage.removeItem(PENDING_INVITE_KEY); }
  return pending;
}

export function resolvePendingInvite(urlToken) {
  const pending = consumePendingInvite();
  const hasFreshToken = typeof urlToken === 'string' && Boolean(urlToken.trim());
  return {
    token: hasFreshToken ? urlToken : pending?.token || null,
    // A URL token starts a new acceptance attempt even when an abandoned OAuth
    // flow left stale storage behind. Only a stash-sourced token is a return leg.
    returning: !hasFreshToken && Boolean(pending),
  };
}

// Google returns to the school root. Leave the record in storage and forward
// to /accept; AcceptInvite consumes it there, preserving its loop guard.
export function pendingInviteResumePath() {
  return readRecord() ? '/accept' : null;
}
